var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

let { property, neighborhood, city_info, isLeadSubmitted, neighborhoods_median_data, neary_neighborhood, display_neighborhood_info, ctaButtonName, ctaText } = options;
    property = property || {};

__p+='\n';
 if(ctaText == 'V1' && ctaButtonName == "Contact Agent") { 
__p+='\n  ';
 ctaButtonName = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n';
 if (property) { 
__p+='\n    ';
 if (neighborhood && display_neighborhood_info) { 
__p+='\n      <p class="link-primary">\n        '+
((__t=( property.address || 'This property' ))==null?'':__t)+
' is located in ';
 if (neighborhood.local_url && neighborhood.area) { 
__p+='<a href="'+
((__t=( `/realestateandhomes-search/${neighborhood.local_url}/overview` ))==null?'':__t)+
'" target="_blank">'+
((__t=( neighborhood.area ))==null?'':__t)+
'</a> neighborhood ';
 } 
__p+='in the city of <a href="'+
((__t=( `/realestateandhomes-search/${city_info.local_url}/overview` ))==null?'':__t)+
'" target="_blank">'+
((__t=( [property.city, property.state_code].join(', ') ))==null?'':__t)+
'</a>.\n      </p>\n      <p class="hidden-qv-xs">\n        ';
 if (property.postal_code && property.street && property.street_suffix) { 
__p+='\n           Checkout other home values in\n            <a href="/propertyrecord-search/'+
((__t=( property.postal_code ))==null?'':__t)+
'/'+
((__t=( property.street ))==null?'':__t)+
'-'+
((__t=( property.street_suffix ))==null?'':__t)+
'" data-omtag="ldp:neighborhood:street" target="_blank">\n              '+
((__t=( property.street ))==null?'':__t)+
' '+
((__t=( property.street_suffix ))==null?'':__t)+
'.\n            </a>\n        ';
 } 
__p+='\n      </p>\n      ';
 if(neighborhoods_median_data) { 
__p+='\n        <ul class="neighborhood-flex-wrapper">\n        ';
 if(neighborhoods_median_data.median_listing_price > 0) { 
__p+='\n          <li class="neighborhood-flex-item">\n            '+
((__t=( neighborhoods_median_data.median_listing_price_display ))==null?'':__t)+
'\n            <span class="neighborhood-flex-item-attribute">\n              Median Listing Price\n            </span>\n          </li>\n        ';
 } 
__p+='\n        ';
 if(neighborhoods_median_data.median_sales_price > 0) { 
__p+='\n          <li class="neighborhood-flex-item">\n            '+
((__t=( neighborhoods_median_data.median_sales_price_display ))==null?'':__t)+
'\n            <span class="neighborhood-flex-item-attribute">\n              Median Sales Price\n            </span>\n          </li>\n        ';
 } 
__p+='\n        ';
 if(neighborhoods_median_data.median_days_on_market) { 
__p+='\n          <li class="neighborhood-flex-item">\n            '+
((__t=( neighborhoods_median_data.median_days_on_market ))==null?'':__t)+
'\n            <span class="neighborhood-flex-item-attribute">\n              Median Days on Market\n            </span>\n          </li>\n        ';
 } 
__p+='\n        ';
 if(neighborhoods_median_data.price_per_sqft_display && neighborhoods_median_data.price_per_sqft_display != 'Price Unavailable') { 
__p+='\n          <li class="neighborhood-flex-item">\n            '+
((__t=( neighborhoods_median_data.price_per_sqft_display ))==null?'':__t)+
'\n            <span class="neighborhood-flex-item-attribute">\n              Price Per Sq Ft\n            </span>\n          </li>\n        ';
 } 
__p+='\n      </ul>\n      ';
 } 
__p+='\n\n      ';
 if(neary_neighborhood && neary_neighborhood.length) { 
__p+='\n        <h3 class="header-subsection margin-top-lg">Nearby Neighborhoods in '+
((__t=( [property.city, property.state_code].join(', ') ))==null?'':__t)+
'</h3>\n        <ul class="neighborhood-flex-wrapper">\n          ';
 neary_neighborhood.forEach((neighborhood) => { 
__p+='\n            <li class="neighborhood-flex-item">\n              <a href="'+
((__t=( `/realestateandhomes-search/${neighborhood.local_url}/overview` ))==null?'':__t)+
'" target="_blank">\n                '+
((__t=( neighborhood.area ))==null?'':__t)+
'\n              </a>\n              <span class="neighborhood-flex-item-attribute">\n                Median Listing:\n                <span class="display-inline-block">'+
((__t=( neighborhood.median_listing_price && neighborhood.median_listing_price != 'Price Unavailable' ? neighborhood.median_listing_price : 'N/A'  ))==null?'':__t)+
'</span>\n              </span>\n            </li>\n          ';
 }) 
__p+='\n        </ul>\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      ';
 if (property.has_suppress_lead_form) { 
__p+='\n        <p>Ask a neighborhood expert for more information.</p>\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n    \n  ';
 if (!isLeadSubmitted && !property.suppress_lead_form && property.display_request_more_details_form && property.has_suppress_lead_form) { 
__p+='\n    <div class="margin-top-lg text-center">\n      ';
 if(neighborhood && display_neighborhood_info) { 
__p+='\n        <span class="font-bold" id="neighborhood-cta-phrase">Ask a neighborhood expert.</span>\n      ';
 } 
__p+='\n      <a href="javascript:void(0)" data-title="Ask a neighborhood expert" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-omtag="ldp:schools:contact-agent" data-placeholder="I would like more information about this neighborhood." data-formid="secondary">\n        <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n          '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n        </span></div>\n      </a>\n    </div>\n  ';
 } 
__p+='\n\n  ';
 if (property.display_amenity_map) { 
__p+='\n    <section class="pos-relative clearfix qv-amenities-wrapper">\n    <h3 class="header-subsection hidden-qv-xs">\n      Explore Schools, Safety, Noise, and Lifestyle around '+
((__t=( property.street_direction ))==null?'':__t)+
' '+
((__t=( property.street ))==null?'':__t)+
' '+
((__t=( property.street_suffix ))==null?'':__t)+
'\n    </h3>\n    <h3 class="header-subsection visible-qv-xs-block">Explore The Neighborhood</h3>\n    <div class="qv-amenities-container js-qv-amenities-map-wrapper">\n      <div id="qv-amenities" class="map-main-container qv-amenities-map"></div>\n      <div class="ldp-amenity-map-attribution amenities-sponsor padding-left">\n          <span class="pull-left font-size-small attribution-text yelp hide-attribution">Powered by</span>\n          <span class="pull-left yelp hide-attribution yelp-logo with-logo"></span>\n          <span class="no-show" id="tracking-url"></span>\n      </div>\n      <div class="pos-relative">\n        <div class="qv-map-crime-sponsor hide-attribution padding-left">\n          <div class="js-crime pull-left font-size-small">\n            Data Provided by\n            <a href="https://www.locationinc.com" target="_blank" rel="nofollow">Location Inc.</a>\n          </div>\n        </div>\n        <div class="qv-map-school-sponsor hide-attribution padding-left">\n          <div class="js-school pull-left font-size-small">\n            Powered by\n            <a href="//www.greatschools.org" target="_blank" rel="nofollow">GreatSchools</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n  ';
 } 
__p+='\n\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/neighborhood/qv-sec-neighborhood.jst.ejs